export default __webpack_public_path__ + "static/template-7fadeb2356d756549e532c1c257efdf2.png";